
import React from 'react'
import Router from '@/router'
import './App.css'

export default function App () {

  return (
    <div className='app'>
      {/* 路由 */}
      <Router></Router>
    </div>
  )
}
